import Cookies from "js-cookie";

import { ENV, MAIN_DOMAIN } from "config";

export const setCookies = (key: string, value: string) => {
  const { hostname } = new URL(MAIN_DOMAIN);
  Cookies.set(key, value, {
    domain: ENV === "development" ? undefined : `.${hostname}`,
    expires: 7, //days,
    secure: ENV !== "development",
  });
};
